// extracted by mini-css-extract-plugin
module.exports = {"tags":"article-tags-module--tags--1_Hpx","tag":"article-tags-module--tag--3EFxb"};